export class StringUtils {
  static decodeHTMLEntities(text: string): string {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  }
}
export const camelize = (str: string) => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};
export const stripHtml = (html: string | undefined) => {
  if (!html) return "";

  const tmp = document.createElement("div");
  tmp.innerHTML = html;

  return tmp.textContent ?? tmp.innerText ?? "";
};
